import { MyTableComponent, Input } from "components"
import { useEffect, useState } from "react"
import { Box } from "theme-ui"
import tittle from "./Tittle.png"
import { useTranslation } from "react-i18next"

export const Revisions = () => {
                // language translator
 const { t } = useTranslation("translation")
 const [selectedData, setSelectedData] = useState<any[]>([])

 const data = [
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },

  {
   firstname: "09.09.2022   (07:56:00)",
   secondname: "09.09.2022   (07:56:00)",
   thirdname: "Test server ",
   fourthname: "UCM-Test Gera",
   fifthname: "Revision durch Wartungsmeldung",
   sixthname: "---",
   seventhname: "---",
   eighthname: "Michael Waldmann",
  },
 ]

 const columns = [
  { Header: t("beginning"), accessor: "firstname" },
  { Header: t("end"), accessor: "secondname" },
  { Header: t("headquarters"), accessor: "thirdname" },
  { Header: t("Attachment"), accessor: "fourthname" },
  { Header: t("remarks"), accessor: "fifthname" },
  { Header: t("reasons"), accessor: "sixthname" },
  { Header: t("Otherwise"), accessor: "seventhname" },
  { Header: t("posted"), accessor: "eighthname" },
 ]

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
  // eslint-disable-next-line
 }, [])
 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: any = data?.filter(
    (item) => item?.secondname?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   setSelectedData(data)
  }
 }

 return (
  <div className="w-[96%] mx-auto relative h-screen  md:h-screen lg:h-full">
   <div className=" py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">Revisionen</h1>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">Revisionen</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">{t("category")}</p>

      <div className="bg-white h-8 w-12 rounded mx-4  border-light-gray border-[1.5px]  flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}
      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder={t("search")}
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
